import {
  Constraint,
  Event,
  Id,
  Identifiable,
  List,
  list,
  Milestone,
  milestone,
  project,
  Project,
  Task,
  task,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = Identifiable<Constraint> & {
  originEntity:
    | Identifiable<Task>
    | Identifiable<List>
    | Identifiable<Event>
    | Identifiable<Milestone>;
  targetEntity:
    | Identifiable<Task>
    | Identifiable<List>
    | Identifiable<Event>
    | Identifiable<Milestone>;
};

function padElement(
  elementType: Constraint["originEntityType"] | Constraint["targetEntityType"],
  element:
    | Identifiable<Task>
    | Identifiable<List>
    | Identifiable<Event>
    | Identifiable<Milestone>,
) {
  return elementType === "ACTIVITY"
    ? { ...list, ...element }
    : elementType === "MILESTONE"
      ? { ...milestone, ...element }
      : { ...task, ...element };
}

function getConstraint(httpClient: HttpClient) {
  return (constraintId: Id) =>
    Promise.all([
      httpClient.sendHttpRequest<Response>({
        endpoint: `/constraints/${constraintId}?projection=details`,
        method: HttpMethods.GET,
      }),
      httpClient.sendHttpRequest<Identifiable<Project>>({
        endpoint: `/constraints/${constraintId}/project`,
        method: HttpMethods.GET,
      }),
    ]).then(([constraint, fetchedProject]) => ({
      ...constraint,
      origin: padElement(constraint.originEntityType, constraint.originEntity),
      target: padElement(constraint.targetEntityType, constraint.targetEntity),
      project: { ...project, ...fetchedProject },
    }));
}

export { getConstraint };
